import React, { useState, useEffect } from "react";
import httpClient from "../../utils/httpClients";

function Profile() {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAccount();
  }, []);

  const fetchAccount = async () => {
    try {
      setLoading(true);
      const res = await httpClient.get("/user/profile/get-profile");
      if (res.data && res.data.success) {
        const userData = res.data.data?.userProfile || {};
        setProfileData(userData);
      } else {
        setError("Failed to fetch profile data");
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
      setError("Error loading profile. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div className="alert alert-danger" role="alert">
          {error}
          <button
            className="btn btn-sm btn-outline-danger ms-3"
            onClick={fetchAccount}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="card-header">
            <div className="header-title">
              <h2 className="card-title text-capitalize mb-3">Profile</h2>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-lg-6">
          <div className="card profile11">
            <div className="card-header d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {profileData?.firstName || profileData?.firstname || "User"}{" "}
                  {profileData?.lastName || profileData?.lastname || ""}
                </h4>
              </div>
            </div>
            <div className="card-body profile1">
              <form>
                <div className="form-group">
                  <div className="profile-img-edit position-relative">
                    <img
                      src={
                        profileData?.displayPic
                          ? profileData.displayPic
                          : `${process.env.PUBLIC_URL}/assets/images/dashboard/64.png`
                      }
                      alt="profile-pic"
                      className="theme-color-default-img profile-pic rounded avatar-100"
                      loading="lazy"
                    />
                  </div>
                </div>

                <div className="profile-details mt-4">
                  <div className="detail-item mb-3">
                    <strong>Email: </strong>
                    <span>{profileData?.email || "N/A"}</span>
                  </div>
                  
                  <div className="detail-item mb-3">
                    <strong>User Type: </strong>
                    <span className={`badge ${
                      profileData?.userType === 'Artist' ? 'bg-success' : 
                      profileData?.userType === 'admin' ? 'bg-danger' : 'bg-primary'
                    }`}>
                      {profileData?.userType === 'Artist' ? 'Artist' : 
                       profileData?.userType === 'admin' ? 'Administrator' : 'Artist'}
                    </span>
                  </div>
                  
                  <div className="detail-item mb-3">
                    <strong>Member since: </strong>
                    <span>{formatDate(profileData?.createdAt)}</span>
                  </div>

                  {profileData?.phone && (
                    <div className="detail-item mb-3">
                      <strong>Phone: </strong>
                      <span>{profileData.phone}</span>
                    </div>
                  )}

                  {profileData?.address && (
                    <div className="detail-item mb-3">
                      <strong>Address: </strong>
                      <span>{profileData.address}</span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Additional profile information can be added here */}
        <div className="col-xl-8 col-lg-6">
          <div className="card profile11">
            <div className="card-header">
              <div className="header-title">
                <h4 className="card-title">Profile Information</h4>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="detail-item mb-3">
                    <strong>First Name:</strong>
                    <p>{profileData?.firstName || profileData?.firstname || "N/A"}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="detail-item mb-3">
                    <strong>Last Name:</strong>
                    <p>{profileData?.lastName || profileData?.lastname || "N/A"}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="detail-item mb-3">
                    <strong>Username:</strong>
                    <p>{profileData?.artist || profileData?.username || profileData?.userName || "N/A"}</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="detail-item mb-3">
                    <strong>Artist Account Status:</strong>
                    <p>
                      <span className="badge bg-success">{profileData?.artistAccountStatus||"Active"}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;